import DeliveriesRoute from 'cio/routes/base-deliveries';

export default class IndexRoute extends DeliveriesRoute {
  model() {
    return this.store.findRecord('campaign', this.paramsFor('campaigns.campaign').campaign_id);
  }

  setupController(controller, model) {
    controller.set('campaign', model.get('id'));

    super.setupController(...arguments);
  }
}
